import Repository from './Repository'
import { API_BASE_PATH } from './ApiPath'

const ADMIN = API_BASE_PATH.ADMIN
const TEAM = 'team'
const ACCOUNT = 'account'

export default {
  getTeamAccount(team_id:number, queries: any) {
    return Repository.get(`${ADMIN}/${TEAM}/${team_id}/${ACCOUNT}`, { params: queries })
  },
  postTeamAccount(team_id:number, data: any) {
    return Repository.post(`${ADMIN}/${TEAM}/${team_id}/${ACCOUNT}`, data)
  },
  updateTeamAccount(team_id:number, data: any) {
    return Repository.put(`${ADMIN}/${TEAM}/${team_id}/${ACCOUNT}`, data)
  },
  deleteTeamAccount(team_id:number, params: any) {
    return Repository.delete(`${ADMIN}/${TEAM}/${team_id}/${ACCOUNT}`, { data: params })
  }
}